
/* ============================== src/components/TagsField.jsx ============================== */
// src/components/TagsField.jsx
//
// Поле «Метки» - один <input type="text"> с классом .inp.
// Разделители (`,` и пробел) обрабатываются не здесь, а в
// utils/tags.parseTagsInput при сохранении: поле хранит «как ввёл
// пользователь», нормализация - на выходе.
import { useId } from "react";

export function TagsField({
  label = "Метки",
  value,
  onChange,
  disabled = false,
  error,
}) {
  const id = `field-${useId()}`;
  return (
    <div className="field-row">
      <label className="field-label" htmlFor={id}>
        {label}
      </label>
      <div className="flex-1">
        <input
          id={id}
          className="inp"
          type="text"
          value={value ?? ""}
          onChange={(e) => onChange(e.target.value)}
          disabled={disabled}
        />
        {error && <div className="field-error">{error}</div>}
      </div>
    </div>
  );
}
